<template>
  <div>
    <br />
    <div class="row">
      <div class="col-xl-3 col-12 my-3">
        <label for=""
          >Référence Vente Vendeur <span class="text-danger">*</span></label
        >
        <input
          type="text"
          v-model="sellerPayment.seller_sale_reference"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""
          >Référence Paiement <span class="text-danger">*</span></label
        >
        <input
          type="text"
          v-model="sellerPayment.payment_reference"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Montant <span class="text-danger">*</span></label>
        <input
          type="number"
          step="0.01"
          v-model="sellerPayment.amount"
          class="form-control"
        />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Date <span class="text-danger">*</span></label>
        <input type="date" v-model="sellerPayment.date" class="form-control" />
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Montant Restant</label>
        <input
          type="number"
          step="0.01"
          v-model="sellerPayment.remainingAmount"
          class="form-control"
        />
      </div>

      <div class="col-xl-12 col-12 my-3">
        <label for=""> Remarque </label>
        <textarea
          v-model="sellerPayment.remark"
          class="form-control"
          rows="3"
        ></textarea>
      </div>
    </div>

    <div class="row mt-3 justify-content-between">
      <div class="col-auto"></div>
      <div class="col-auto">
        <button class="btn btn-success" @click="save(sellerPayment)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      sellerPayment: {
        date: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
      },
    };
  },
  computed: {
    ...mapGetters("auth", {
      user: "getAuthData",
    }),
  },
  methods: {
    async save(data) {
      data.user_reference = this.user && this.user.reference;
      await this.$store.dispatch("sellerPayment/store", data);
    },
  },
};
</script>
